const STORAGE_PREFIX = "atlas-chat-draft";

/** Draft slot for the composer when no session is selected (new chat). */
export const NEW_CHAT_DRAFT_KEY = "__new__";

export function getChatDraftKey(sessionId: string | undefined): string {
    return sessionId ?? NEW_CHAT_DRAFT_KEY;
}

function storageKey(bagId: number, draftKey: string): string {
    return `${STORAGE_PREFIX}:${bagId}:${draftKey}`;
}

export function readChatDraft(bagId: number, draftKey: string): string {
    try {
        return localStorage.getItem(storageKey(bagId, draftKey)) ?? "";
    } catch {
        return "";
    }
}

export function writeChatDraft(
    bagId: number,
    draftKey: string,
    text: string,
): void {
    try {
        const key = storageKey(bagId, draftKey);
        if (!text) {
            localStorage.removeItem(key);
        } else {
            localStorage.setItem(key, text);
        }
    } catch {
        // ignore quota / private mode
    }
}

export function clearChatDraft(bagId: number, draftKey: string): void {
    writeChatDraft(bagId, draftKey, "");
}
